import API from '@/api/apiUrls'
import { useApi } from '@/api/useApi'
import { defineStore } from 'pinia'

import type { ProjectUserType } from '@/stores/type/projectUser.type'
import { useBaseStore } from '@haskoning/vue-basestore'
import { useAuthModelBaseStore } from '@haskoning/vue-basestore'

const { api } = useApi()
const baseUrl = API.CORE.PROJECT_USERS.INDEX

export const useProjectUserStore = defineStore('projectUsers', () => {
  const baseStore = useBaseStore<ProjectUserType>({ service: baseUrl, api })
  const authModelBaseStore = useAuthModelBaseStore(baseStore)

  function resetState() {
    baseStore.items.value = []
    baseStore.currentItem.value = null
  }

  return {
    ...baseStore,
    ...authModelBaseStore,
    resetState
  }
})
